import { TextField, Tooltip } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { SharedFieldInputProps } from "./types";
import { dateValueToPickerDate, formatRelativeTimeFromNow, getUserDateTimePreferences, pickerDateToDateValue, pickerFormatPlaceholder, toDateFnsPickerFormat } from "../services/dateTimePreferences";
import { useSession } from "app/hooks/useSession";
import { useTranslation } from "react-i18next";
import { usePickerDraftValue } from "./usePickerDraftValue";

export function DateFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    fullWidth = true,
    size = "small",
    disabled = false,
}: SharedFieldInputProps<string | null>) {
    const { data: user } = useSession();
    const { i18n } = useTranslation();
    const language = i18n.resolvedLanguage || i18n.language || user?.preferredLanguage || "en";
    const preferences = getUserDateTimePreferences(user, language);
    const { pickerValue, handlePickerChange } = usePickerDraftValue(value, dateValueToPickerDate, pickerDateToDateValue, onChange);
    const relativeTime = formatRelativeTimeFromNow(value, {
        language,
        dateOnly: true,
    });

    return (
        <DatePicker
            value={pickerValue}
            inputFormat={toDateFnsPickerFormat(preferences.dateFormat)}
            onChange={(date) => handlePickerChange(date as Date | null)}
            disabled={disabled}
            renderInput={(params) => (
                <Tooltip title={relativeTime}>
                    <TextField
                        {...params}
                        inputProps={{ ...params.inputProps, placeholder: pickerFormatPlaceholder(preferences.dateFormat, language) }}
                        fullWidth={fullWidth}
                        size={size}
                        InputLabelProps={{ shrink: true }}
                        error={error}
                        helperText={helperText}
                    />
                </Tooltip>
            )}
        />
    );
}
